import BUILD_INFO from '../../../generated/buildInfo';

export const CURRENT_SCHEMA_VERSION = BUILD_INFO.requiredSchemaVersion;

export type VersionCompatibility =
  | 'current'
  | 'minor-upgrade'
  | 'major-upgrade'
  | 'downgrade-blocked';

type ParsedVersion = {
  major: number;
  minor: number;
};

const parseVersion = (value: string): ParsedVersion => {
  const match = /(\d+)\.(\d+)/.exec(value);
  if (!match) {
    return { major: 0, minor: 0 };
  }
  return {
    major: Number(match[1]),
    minor: Number(match[2])
  };
};

export const isCompatible = (siteVersion: string, installerVersion: string): VersionCompatibility => {
  const site = parseVersion(siteVersion);
  const installer = parseVersion(installerVersion);
  if (site.major > installer.major) return 'downgrade-blocked';
  if (site.major < installer.major) return 'major-upgrade';
  if (site.minor < installer.minor) return 'minor-upgrade';
  if (site.minor === installer.minor) return 'current';
  return 'downgrade-blocked';
};
